import React, {useEffect, useMemo, useState} from 'react';
import SPSelectWithEnum from "../../../base/SPSelectWithEnum";
import {Form, Input, Cascader, Space, Button, Modal} from "antd";
import {useServicePolicyTemplate} from "../../../../../hooks/product-price/service-policy-template";

const { SHOW_CHILD, SHOW_PARENT } = Cascader;
interface PropsType {
    enums: any
    id: any
    value?: any
    onChange?: any
}

const UseCarLimit: React.FC<PropsType> = (props) => {
    const { id, value, enums, onChange } = props
    const form = Form.useFormInstance();
    const selectName1 = `${id}_select1`
    const selectName2 = `${id}_select2`
    const selectName3 = `${id}_select3`
    const [ limitFlag, setLimitFlag ] =  useState<any>()
    const [ label1, setLabel1 ] =  useState<any>()
    const [ label2, setLabel2 ] =  useState<any>()
    const [ label3, setLabel3 ] =  useState<any>()
    const [ options, setOptions ] =  useState<any>()
    const { getCityList } = useServicePolicyTemplate();


    useEffect(() => {
        getCityList().then((res) => {
            setOptions(res.data)
        })
        if (value?.length !== 6) return
        setLabel1(value[0] || '')
        setLabel2(value[2] || '')
        setLabel3(value[4] || '')
        if (value[1] === 1) {
            setLimitFlag(1)
        }
        if (value[1] === 2) {
            value[3] = []
            value[5] = []
        }
        form.setFieldsValue({
            ...form.getFieldsValue(),
            [selectName1]: value[1],
            [selectName2]: value[3] || [],
            [selectName3]: value[5] || [],
        })
    }, []);

    const onChangeType = (e: any) => {
        setLimitFlag(e)
        value[1] = e
        if (value[1] === 2) {
            value[3] = []
            value[5] = []
        }
        processData(value)
    }
    const onChangeCarIn = (e: any) => {
        value[3] = e
        processData(value)
    }
    const onChangeCarOut = (e: any) => {
        value[5] = e
        processData(value)
    }

    const processData = (value: any) => {
        value[3] = value[3] || []
        value[5] = value[5] || []
        onChange(value)
    }

    return (
        <>
            <Form.Item name={selectName1} label={label1} rules={[{ required: true, message: '请选择' }]}>
                <SPSelectWithEnum enums={enums} enumKey={'is_limit'} onChange={onChangeType} />
            </Form.Item>
            {
                limitFlag === 1 ?
                    <>
                        <Form.Item name={selectName2} rules={[
                            ({ getFieldValue }) => ({
                                validator(_, value) {
                                    if ((!value || value.length === 0) && (!getFieldValue(selectName3) || getFieldValue(selectName3).length === 0)) {
                                        return Promise.reject(new Error('驶入驶出区域至少填一个'));
                                    }
                                    return Promise.resolve()
                                },
                            }),
                        ]} label={label2}>
                            <Cascader
                                fieldNames={{ label: 'name', value: 'name', children: 'child' }}
                                onChange={onChangeCarIn}
                                style={{ width: '100%' }}
                                options={options}
                                multiple
                                showCheckedStrategy={SHOW_PARENT}
                                defaultValue={[
                                    ['bamboo', 'little', 'fish'],
                                    ['bamboo', 'little', 'cards'],
                                    ['bamboo', 'little', 'bird'],
                                ]}
                            />
                        </Form.Item>
                        <Form.Item  name={selectName3} rules={[
                            ({ getFieldValue }) => ({
                                validator(_, value) {
                                    if ((!value || value.length === 0) && (!getFieldValue(selectName2) || getFieldValue(selectName2).length === 0)) {
                                        return Promise.reject(new Error('驶入驶出区域至少填一个'));
                                    }
                                    return Promise.resolve()
                                },
                            }),
                        ]} label={label3}>
                            <Cascader
                                fieldNames={{ label: 'name', value: 'name', children: 'child' }}
                                onChange={onChangeCarOut}
                                style={{ width: '100%',}}
                                options={options}
                                multiple
                                showCheckedStrategy={SHOW_PARENT}
                                defaultValue={[
                                    ['bamboo', 'little', 'fish'],
                                    ['bamboo', 'little', 'cards'],
                                    ['bamboo', 'little', 'bird'],
                                ]}
                            />
                        </Form.Item>
                    </>
                    : <></>
            }
        </>
    )
}

export default UseCarLimit;


